import 'plyr/src/sass/plyr.scss';

VIV.behaviours.video = (function(){
    const attach = function (context) {
        context.querySelectorAll('.video').forEach(initVideo);
    };

    const initVideo = function (element) {
        import(/* webpackChunkName: "video" */ "plyr").then(module => {
            const Plyr = module.default;
            const player = new Plyr(element);
        });
    };

    return {
        attach: attach
    }
})();
